import React from 'react';
// Path check kar lein
import herbalVideo from '../assets/sidevdo.mp4'; 

const HerbalCommitment: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#fffcf1] py-12 px-4 sm:px-6 lg:px-8 flex items-center">
      
      
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:grid lg:grid-cols-2 gap-12 items-center">
        
       
        <div className="w-full flex justify-center lg:justify-start">
           
            <div className="relative w-full h-[400px] lg:h-[600px] rounded-2xl overflow-hidden shadow-xl bg-black">
                <video
                    src={herbalVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover"
                    // SEO: Descriptive title for the video content
                    title="Ayurvedic herbal processing and organic farming techniques at Ayush Vatika"
                />
            </div>
        </div>

        
        <div className="flex flex-col space-y-10 w-full">
          {/* SEO: Main Heading for this section */}
          <h2 className="text-3xl font-bold text-[#334a21] mb-2">Our Commitment to Purity</h2>
          
          {/* Step 1 */}
          <div className="flex items-start gap-4">
             <div className="flex-shrink-0 mt-1">
              <svg className="h-8 w-8 text-[#334a21]" fill="currentColor" viewBox="0 0 20 20"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"></path></svg>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-1 text-[#334a21]">STEP 1</h3>
              {/* Keyword: Soil Health, Nutrient-dense */}
              <h4 className="text-xl font-semibold mb-2 text-[#334a21]">Organic Farming & Soil Health</h4>
              <p className="text-sm text-[#334a21] opacity-90 leading-relaxed">
                To obtain maximum potency from an Ayurvedic herb, we plant seeds in micronutrient-dense soil sustained by regenerative agricultural practices.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex items-start gap-4">
             <div className="flex-shrink-0 mt-1">
              <svg className="h-8 w-8 text-[#334a21]" fill="currentColor" viewBox="0 0 20 20"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"></path></svg>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-1 text-[#334a21]">STEP 2</h3>
              {/* Keyword: Harvest, Potency */}
              <h4 className="text-xl font-semibold mb-2 text-[#334a21]">Peak Potency Harvesting</h4>
              <p className="text-sm text-[#334a21] opacity-90 leading-relaxed">
                We allow our herbs to flourish until the right moment to harvest to ensure the highest medicinal value of each plant.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex items-start gap-4">
             <div className="flex-shrink-0 mt-1">
              <svg className="h-8 w-8 text-[#334a21]" fill="currentColor" viewBox="0 0 20 20"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"></path></svg>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-1 text-[#334a21]">STEP 3</h3>
              {/* Keyword: Whole-plant extraction */}
              <h4 className="text-xl font-semibold mb-2 text-[#334a21]">Traditional Whole-Plant Extraction</h4>
              <p className="text-sm text-[#334a21] opacity-90 leading-relaxed">
                Every herb is carefully extracted using traditional methods, without harsh solvents or chemicals, to preserve its beneficial properties.
              </p>
            </div>
          </div>
          
          {/* Step 4 */}
          <div className="flex items-start gap-4">
             <div className="flex-shrink-0 mt-1">
              <svg className="h-8 w-8 text-[#334a21]" fill="currentColor" viewBox="0 0 20 20"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"></path></svg>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-1 text-[#334a21]">STEP 4</h3>
              {/* Keyword: ISO Certified, Lab Tested */}
              <h4 className="text-xl font-semibold mb-2 text-[#334a21]">Lab Tested for Purity & Safety</h4>
              <p className="text-sm text-[#334a21] opacity-90 leading-relaxed">
                Each product is tested for microbes and heavy metals in our on-site ISO-Certified laboratory to ensure 100% safety.
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default HerbalCommitment;